import { createSlice } from "@reduxjs/toolkit";
import apiClient from "../../auth/apiClient";
import ReportQueueService from "../../services/ReportQueueService";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const fetchRequestsByEntityID = createAsyncThunk(
    "reportQueue/fetchRequests",
    async ({ entityID }, thunkAPI) => {
        try {
            const response = await reportQueueService.getReportQueueRecords(entityID);

            if (!response ) {
                return [];
            }

            return { entityId: entityID, requests: response };
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    }
);

const initialState = {
  requests: [],
  loading: false,
  error: undefined,
};

const reportQueueService = new ReportQueueService(apiClient);


// This can be removed i believe
const reportQueueSlice = createSlice({
  name: "reportQueue",
  initialState,
  extraReducers:  (builder) => {
        builder
        .addCase(fetchRequestsByEntityID.fulfilled, (state, action) => {        
                       state.requests = action.payload.requests;
                       state.loading = false;
                    })
        .addCase(fetchRequestsByEntityID.pending, (state) => {
                       state.loading = true;
                    })
        .addCase(fetchRequestsByEntityID.rejected, (state) => {
                       state.loading = false;
                       state.error = "Unable to load the queue listing, please try again later.";
                    })
  }
});

export default reportQueueSlice.reducer;

